import { Fragment, FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import Axios from 'axios'
import pluralize from 'pluralize'
import { EditableText } from 'src/ui/editable-text/functional'
import { classes } from 'src/utils/css'

import { IPlaylist } from './types'
import { getDurationMinutes, getItemsCountString, getUpdatedAtString } from './utils'

export const PlaylistChip: FunctionalComponent<
  { playlist: IPlaylist; size: 'sm' | 'lg' } & JSXBase.IntrinsicElements['div']
> = ({ playlist, size = 'sm' }) => {
  const durationMinutes = getDurationMinutes(playlist)
  const itemsCountString = getItemsCountString(playlist)
  const updatedAtString = getUpdatedAtString(playlist)
  return (
    <div class={`flex flex-col spacing-y-${size === 'sm' ? '2px' : '4px'}`}>
      <div class='flex'>
        {playlist.actions?.updateUrl ? (
          <span
            class={`${classes(
              size === 'sm',
              'text-2xlarge font-black',
              'text-3xlarge font-bold'
            )} flex text-white w-full`}
          >
            <EditableText
              style={{ 'min-width': '100px' }}
              onChange={(e) => {
                Axios.put(playlist.actions.updateUrl, { name: (e.target as HTMLInputElement).innerText })
              }}
              value={playlist.name}
            />
          </span>
        ) : (
          <span class={`${classes(size === 'sm', 'text-2xlarge font-black', 'text-3xlarge font-bold')} text-white`}>
            {playlist.name}
          </span>
        )}
      </div>
      <div class='flex items-center text-md font-semibold text-gray-90 spacing-x-4px'>
        {playlist.hashtag && (
          <Fragment>
            <span class='text-brand-base'>#{playlist.hashtag}</span>
            <span class='w-4px h-4px bg-gray-400 rounded-full' />
          </Fragment>
        )}
        <span class=''>
          {itemsCountString} ({durationMinutes} {pluralize('min', durationMinutes)})
        </span>
        <span class='w-4px h-4px bg-gray-400 rounded-full' />
        <span class=''>last updated {updatedAtString}</span>
      </div>
    </div>
  )
}
